import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractOptionComponent} from '../abstract-option/abstract-option.component';

import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-choice-option',
  imports: [
    FormsModule
],
  templateUrl: './choice-option.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './choice-option.component.scss'
})
export class ChoiceOptionComponent extends AbstractOptionComponent {
  choices: any[] = [];
  value: any | null = null;

  setData(data: any): void {
    this.choices = [];

    if (Array.isArray(data.choices)) {
      for (const choice of data.choices) {
        this.choices.push({
          label: choice.label,
          value: choice.value
        });
      }
    }
  }

  getValue(): any {
    return this.value;
  }

  setValue(value: any): void {
    if (value === true) {
      this.value = 1;
    } else if (value === false) {
      this.value = 0;
    } else {
      this.value = value;
    }
  }
}
